import type { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { login } from '../../../utils/auth/auth'
import ChevronRight from '../../../assets/icons/chevronRight.svg'

const StyledButton = styled.button`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  background-color: transparent;
  display: inline-flex;
  align-items: center;
  padding: 0;
  color: inherit;
  svg {
    width: 12px;
    height: 12px;
    margin: 0 0.25rem 0 0;
  }

  &:hover {
    color: var(--lightGrey);
  }
`

const LoginLink: FunctionComponent<{ showChevron?: boolean; children?: ReactNode }> = ({
  showChevron = true,
  children,
}) => {
  return (
    <StyledButton type="button" data-testid="link" onClick={login}>
      {showChevron && <ChevronRight />}
      {children || 'Inloggen'}
    </StyledButton>
  )
}

export default LoginLink
